// import React, { useState, useEffect, useCallback, useRef } from "react";
// import {
//   Box, Grid, Card, CardContent, Typography, CircularProgress, Chip,
//   TextField, InputAdornment,
// } from "@mui/material";
// import {
//   CheckCircle, ErrorOutline, InfoOutlined, Refresh,
//   Factory, Warehouse, HourglassEmpty, Warning, Build, LocalShipping,
//   Person, Search, LocationOn, DirectionsCar,
// } from "@mui/icons-material";
// import axiosClient from "../../configs/axios";

// // ── Design tokens (matches ManagementDashboard / PlantDashboard) ──────────────
// const C = {
//   navy:     "#1B3A6B",
//   accent:   "#2563EB",
//   bg:       "#F0F4F8",
//   card:     "#FFFFFF",
//   border:   "#E2E8F0",
//   success:  "#16A34A", successBg: "#DCFCE7",
//   warn:     "#D97706", warnBg:    "#FEF3C7",
//   err:      "#DC2626", errBg:     "#FEE2E2",
//   info:     "#2563EB", infoBg:    "#EFF6FF",
//   muted:    "#64748B",
// };


// const Q = "page=0&&size=999&&searchKey=";
// const REFRESH_MS = 60_000;

// // ── Helpers ───────────────────────────────────────────────────────────────────
// const getArr = (res) => {
//   if (res.status !== "fulfilled") return [];
//   const d = res.value?.data;
//   if (Array.isArray(d)) return d;
//   if (Array.isArray(d?.data)) return d.data;
//   return [];
// };

// // ── SectionCard (same pattern as ManagementDashboard) ─────────────────────────
// const SectionCard = ({ title, icon: Icon, iconColor = C.accent, badge, loading, children, headerRight }) => (
//   <Card elevation={0} sx={{ border: `1px solid ${C.border}`, borderRadius: "12px", bgcolor: C.card, height: "100%" }}>
//     <CardContent sx={{ p: "18px 20px !important" }}>
//       <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5, flexWrap: "wrap", gap: 1 }}>
//         <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
//           <Icon sx={{ fontSize: 16, color: iconColor }} />
//           <Typography sx={{ fontSize: 13, fontWeight: 700, color: C.navy }}>{title}</Typography>
//           {badge && (
//             <Chip label={badge} size="small"
//               sx={{ fontSize: 10, fontWeight: 600, height: 20, bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE" }}
//             />
//           )}
//         </Box>
//         {headerRight}
//       </Box>
//       {loading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 120 }}>
//           <CircularProgress size={26} sx={{ color: C.accent }} />
//         </Box>
//       ) : children}
//     </CardContent>
//   </Card>
// );

// // ── Stat Box ─────────────────────────────────────────────────────────────────
// const StatBox = ({ label, value, color = C.navy, bg = "#F8FAFC", loading }) => (
//   <Box sx={{ textAlign: "center", p: "12px 8px", borderRadius: "10px", bgcolor: bg, border: `1px solid ${C.border}` }}>
//     {loading ? (
//       <CircularProgress size={16} sx={{ color }} />
//     ) : (
//       <Typography sx={{ fontSize: 22, fontWeight: 700, color, lineHeight: 1 }}>
//         {value ?? "—"}
//       </Typography>
//     )}
//     <Typography sx={{ fontSize: 10, color: C.muted, textTransform: "uppercase", mt: 0.5, letterSpacing: 0.4, fontWeight: 600 }}>
//       {label}
//     </Typography>
//   </Box>
// );

// // ── Row item (plant production rows) ──────────────────────────────────────────
// const DataRow = ({ label, v1, v1c = C.accent, l1, v2, v2c = C.success, l2, v3, v3c = C.warn, l3 }) => (
//   <Box sx={{
//     display: "flex", alignItems: "center", justifyContent: "space-between",
//     py: 1, borderBottom: `1px solid ${C.border}`, "&:last-child": { borderBottom: "none" },
//   }}>
//     <Typography sx={{ fontSize: 12, fontWeight: 600, color: C.navy, flex: 2, pr: 1 }}>{label}</Typography>
//     <Box sx={{ display: "flex", gap: 1.5, justifyContent: "flex-end" }}>
//       <Box sx={{ textAlign: "center", minWidth: 52 }}>
//         <Typography sx={{ fontSize: 14, fontWeight: 700, color: v1c }}>{v1 ?? "—"}</Typography>
//         <Typography sx={{ fontSize: 9, color: C.muted, textTransform: "uppercase", letterSpacing: 0.3 }}>{l1}</Typography>
//       </Box>
//       {l2 && (
//         <Box sx={{ textAlign: "center", minWidth: 52 }}>
//           <Typography sx={{ fontSize: 14, fontWeight: 700, color: v2c }}>{v2 ?? "—"}</Typography>
//           <Typography sx={{ fontSize: 9, color: C.muted, textTransform: "uppercase", letterSpacing: 0.3 }}>{l2}</Typography>
//         </Box>
//       )}
//       {l3 && (
//         <Box sx={{ textAlign: "center", minWidth: 52 }}>
//           <Typography sx={{ fontSize: 14, fontWeight: 700, color: v3c }}>{v3 ?? "—"}</Typography>
//           <Typography sx={{ fontSize: 9, color: C.muted, textTransform: "uppercase", letterSpacing: 0.3 }}>{l3}</Typography>
//         </Box>
//       )}
//     </Box>
//   </Box>
// );

// // ── Alert row ─────────────────────────────────────────────────────────────────
// const AlertRow = ({ type = "info", title, sub }) => {
//   const M = {
//     err:  { bg: C.errBg,  border: C.err,  Icon: ErrorOutline, ic: C.err  },
//     warn: { bg: C.warnBg, border: C.warn, Icon: Warning,      ic: C.warn },
//     info: { bg: C.infoBg, border: C.info, Icon: InfoOutlined, ic: C.info },
//     ok:   { bg: C.successBg, border: C.success, Icon: CheckCircle, ic: C.success },
//   };
//   const { bg, border, Icon, ic } = M[type] || M.info;
//   return (
//     <Box sx={{ display: "flex", gap: 1, p: "8px 12px", borderLeft: `3px solid ${border}`, bgcolor: bg, mb: 0.75, borderRadius: "0 8px 8px 0", "&:last-child": { mb: 0 } }}>
//       <Icon sx={{ fontSize: 15, color: ic, mt: "2px", flexShrink: 0 }} />
//       <Box>
//         <Typography sx={{ fontSize: 12, fontWeight: 600, color: C.navy, lineHeight: 1.3 }}>{title}</Typography>
//         {sub && <Typography sx={{ fontSize: 11, color: C.muted, mt: 0.2 }}>{sub}</Typography>}
//       </Box>
//     </Box>
//   );
// };

// // ── Column header ─────────────────────────────────────────────────────────────
// const ColHeader = ({ cols }) => (
//   <Box sx={{ display: "flex", justifyContent: "space-between", pb: 0.75, mb: 0.5, borderBottom: `1.5px solid ${C.border}` }}>
//     <Typography sx={{ fontSize: 10, color: C.muted, fontWeight: 700, flex: 2, textTransform: "uppercase", letterSpacing: 0.4 }}>{cols[0]}</Typography>
//     {cols.slice(1).map((c, i) => (
//       <Typography key={i} sx={{ fontSize: 10, color: C.muted, fontWeight: 700, textAlign: "center", minWidth: 52, textTransform: "uppercase", letterSpacing: 0.4 }}>{c}</Typography>
//     ))}
//   </Box>
// );

// // ══════════════════════════════════════════════════════════════════════════════
// //  MAIN COMPONENT
// // ══════════════════════════════════════════════════════════════════════════════
// const AdminDashboard = () => {
//   const [plantRows, setPlantRows]     = useState([]);
// const [depotStats, setDepotStats]   = useState({
//     full: null, empty: null, maintenance: null,
//     plantFull: null, plantEmpty: null,
//     depotFull: null, depotEmpty: null,
//     inTransit: null,
//   });
//   const [qcStats, setQcStats]         = useState({ ok: null, failed: null, total: null });
//   const [alerts, setAlerts]           = useState([]);
//   const [depotCylRows, setDepotCylRows] = useState([]);
//   const [loading, setLoading]         = useState(true);
//   const [lastRefreshed, setLastRefreshed] = useState(null);
//   const [holdingSynopsis, setHoldingSynopsis] = useState({ totalCustomers: 0, totalCylinders: 0 });
//   const [allCustomers, setAllCustomers] = useState([]);          // all 161 customers
//   const [holdingData, setHoldingData] = useState([]);            // customers holding cylinders
//   const [inTransitData, setInTransitData] = useState([]);        // in-transit cylinders
//   const [custSearch, setCustSearch] = useState("");              // search filter
//   const timerRef = useRef(null);

//   const fetchAll = useCallback(async () => {
//     setLoading(true);
//     try {
//       const [
//         productionRes,
//         inventoryRes,
//         depotCylRes,
//         holdingRes,
//         qcSummaryRes,
//          customerCountRes,
//         allCustomersRes,
//         inTransitRes,
//       ] = await Promise.allSettled([
//         axiosClient.get("/dashboard/production"),
//         axiosClient.get("/dashboard/inventory"),
//         axiosClient.get("/dashboard/depot-cylinder-count"),
//         axiosClient.get(`/reports/EmptyCylinderHolding?page=0&size=999&searchKey=`),
//         axiosClient.get("/dashboard/qc-summary"),
//          // BAAD (sahi):
// axiosClient.get("/customers/list?page=0&size=1&searchKey="),
//         axiosClient.get(`/customers/list?page=0&size=999&searchKey=`),
//         axiosClient.get(`/cylinder/intransit`),
//       ]);

//       // Plant rows
//       const prodData = (() => {
//         if (productionRes.status !== "fulfilled") return [];
//         const d = productionRes.value?.data;
//         return Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : []);
//       })();
//       const plantMap = {};
//       prodData.forEach((row) => {
//         const key = row.plant_name || "Unknown";
//         if (!plantMap[key]) plantMap[key] = { name: key, qty: 0, cylinders: 0, carbide: 0, acetone: 0 };
//         plantMap[key].qty       += parseFloat(row.total_qty_filled || 0);
//         plantMap[key].cylinders += parseInt(row.cylinder_count || 0, 10);
//         plantMap[key].carbide   += parseFloat(row.carbide || 0);
//         plantMap[key].acetone   += parseFloat(row.acetone || 0);
//       });
//       setPlantRows(Object.values(plantMap));

//       // Depot stats
// if (inventoryRes.status === "fulfilled") {
//         const inv = inventoryRes.value?.data;
//         if (inv) {
//           setDepotStats({
//             full:        (inv.full?.tgpl  || 0) + (inv.full?.customer  || 0),
//             empty:       (inv.empty?.tgpl || 0) + (inv.empty?.customer || 0),
//             maintenance: inv.maintenance || 0,
//             plantFull:   inv.plant?.full  || 0,
//             plantEmpty:  inv.plant?.empty || 0,
//             depotFull:   inv.depot?.full  || 0,
//             depotEmpty:  inv.depot?.empty || 0,
//             inTransit:   inv.inTransit || 0,
//           });
//         }
//       }
//       // Depot wise cylinder count
//       const depotCylData = depotCylRes.status === "fulfilled"
//         ? (Array.isArray(depotCylRes.value?.data) ? depotCylRes.value.data : [])
//         : [];
//       setDepotCylRows(depotCylData);

//       // QC stats — from cylinder_master.result (QCPASS / QCFAIL)
//       if (qcSummaryRes.status === "fulfilled") {
//         const qc = qcSummaryRes.value?.data || {};
//         setQcStats({
//           ok:     Number(qc.qc_pass || 0),
//           failed: Number(qc.qc_fail || 0),
//           total:  Number(qc.total_inspected || 0),
//         });
//       } else {
//         setQcStats({ ok: 0, failed: 0, total: 0 });
//       }

//       // Alerts (top customer holding)
//      const holdingData = getArr(holdingRes);

//       // Total customers — from customer_master table
//       const customerListData = getArr(customerCountRes);
//       const totalCustomersFromMaster = customerListData.length > 0
//         ? Number(customerListData[0].totalCount || 0)
//         : 0;

//       // Total customer synopsis
//       setHoldingSynopsis({
//         totalCustomers: totalCustomersFromMaster,
//         totalCylinders: holdingData.reduce((s, r) => s + Number(r.total_cylinders || 0), 0),
//       });

//       const newAlerts = [];
//       const sorted = [...holdingData].sort((a, b) => (b.total_cylinders || 0) - (a.total_cylinders || 0));
//       if (sorted.length === 0) {
//         newAlerts.push({ type: "ok", title: "No customer holding", sub: "No cylinders currently held by customers" });
//       } else {
//         sorted.slice(0, 5).forEach((row) => {
//           newAlerts.push({
//             type: "info",
//             title: row.customer_name || "Unknown Customer",
//             sub: `${row.total_cylinders || 0} cylinders held`,
//           });
//         });
//       }
//       setAlerts(newAlerts);

//       // ── All Customers list ─────────────────────────────────────────────────
//       const allCustRaw = getArr(allCustomersRes);
//       setAllCustomers(allCustRaw);

//       // ── Customer holding data (cylinders held per customer) ───────────────
//       const holdRaw = getArr(holdingRes);
//       setHoldingData(holdRaw);

//       // ── In-Transit cylinders ────────────────────────────────────────────────
//       const inTransitRaw = (() => {
//         if (inTransitRes.status !== "fulfilled") return [];
//         const d = inTransitRes.value?.data;
//         if (Array.isArray(d)) return d;
//         if (Array.isArray(d?.data)) return d.data;
//         return [];
//       })();
//       setInTransitData(inTransitRaw);

//       setLastRefreshed(new Date());

//     } catch (err) {
//       console.error("AdminDashboard error:", err);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchAll();
//     if (timerRef.current) clearInterval(timerRef.current);
//     timerRef.current = setInterval(fetchAll, REFRESH_MS);
//     return () => clearInterval(timerRef.current);
//   }, [fetchAll]);

//   const totalQty       = plantRows.reduce((s, r) => s + r.qty, 0);
//   const totalCylinders = plantRows.reduce((s, r) => s + r.cylinders, 0);
//   const totalCarbide   = plantRows.reduce((s, r) => s + r.carbide, 0);

// const depotTotalFull  = depotCylRows.reduce((s, r) => s + Number(r.full_count  || 0), 0);
// const depotTotalEmpty = depotCylRows.reduce((s, r) => s + Number(r.empty_count || 0), 0);
// const depotTotalAll   = depotCylRows.reduce((s, r) => s + Number(r.total_count || 0), 0);

//   return (
//     <Box sx={{ p: { xs: "12px", sm: "16px", md: "20px" }, bgcolor: C.bg, minHeight: "100vh" }}>

//       {/* ══ HEADER ══ */}
//       <Box sx={{
//         display: "flex", alignItems: "center", justifyContent: "space-between",
//         flexWrap: "wrap", gap: 2, mb: 2.5,
//       }}>
//         <Box>
//           <Typography sx={{ fontSize: 18, fontWeight: 700, color: C.navy }}>Admin Dashboard</Typography>
//           <Typography sx={{ fontSize: 12, color: C.muted, mt: 0.3 }}>
//             Plant Production · Depot Inventory · Inspection Status · Customer Holding
//           </Typography>
//         </Box>

//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
//           {lastRefreshed && (
//             <Typography sx={{ fontSize: 11, color: C.muted }}>
//               Updated {lastRefreshed.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
//             </Typography>
//           )}
//           <Chip
//             label="Admin" size="small"
//             icon={<CheckCircle sx={{ fontSize: "13px !important", color: `${C.info} !important` }} />}
//             sx={{ bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE", fontSize: 11, fontWeight: 500 }}
//           />
//           <Box component="span" onClick={fetchAll} title="Refresh now"
//             sx={{ cursor: "pointer", color: C.muted, display: "flex", alignItems: "center", "&:hover": { color: C.accent } }}>
//             <Refresh sx={{ fontSize: 18 }} />
//           </Box>
//         </Box>
//       </Box>

//     <Grid container spacing={2}>

//         {/* ══ ROW 1: Depot Cylinder Stock + Plant & Depot Stock ══ */}

//         {/* Depot — Cylinder Stock */}
//         <Grid item xs={12} lg={6}>
//           <SectionCard title="Depot — Cylinder Stock" icon={Warehouse} iconColor="#0891B2" loading={loading} badge="Live">
//             <Grid container spacing={1.5}>
//               <Grid item xs={6}>
//                 <StatBox label="Full Cylinders"  value={depotStats.full}        color={C.success} bg={C.successBg} />
//               </Grid>
//               <Grid item xs={6}>
//                 <StatBox label="Empty Cylinders" value={depotStats.empty}       color={C.warn}    bg={C.warnBg} />
//               </Grid>
//               <Grid item xs={6}>
//                 <StatBox label="In Maintenance"  value={depotStats.maintenance} color={C.err}     bg={C.errBg} />
//               </Grid>
//               <Grid item xs={6}>
//                 <StatBox label="Total In-Transit" value={depotStats.inTransit} color={C.accent} bg={C.infoBg} />
//               </Grid>
//             </Grid>
//           </SectionCard>
//         </Grid>

//         {/* Cylinder Stock — Plant & Depot */}
//         <Grid item xs={12} lg={6}>
//           <SectionCard title="Cylinder Stock — Plant & Depot" icon={Warehouse} iconColor="#0891B2" loading={loading} badge="Live">
//             <ColHeader cols={["Location", "Full", "Empty"]} />
//             <DataRow
//               label="Plant"
//               v1={depotStats.plantFull}  l1="Full"  v1c={C.success}
//               v2={depotStats.plantEmpty} l2="Empty" v2c={C.warn}
//             />
//             <DataRow
//               label="Depot"
//               v1={depotStats.depotFull}  l1="Full"  v1c={C.success}
//               v2={depotStats.depotEmpty} l2="Empty" v2c={C.warn}
//             />
//           </SectionCard>
//         </Grid>

//         {/* ══ ROW 2: Top Customer Cylinder Holding ══ */}

  
//         <Grid item xs={12}>
//           <SectionCard title="Top Customer Cylinder Holding" icon={HourglassEmpty} iconColor={C.warn} loading={loading} badge="Top 5">
//             <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
//               <Grid item xs={6} sm={3}>
//                 <StatBox label="Total Customers"  value={holdingSynopsis.totalCustomers} color={C.accent} bg={C.infoBg} />
//               </Grid>
//               {/* <Grid item xs={6} sm={3}>
//                 <StatBox label="Cylinders Held"   value={holdingSynopsis.totalCylinders} color={C.warn}   bg={C.warnBg} />
//               </Grid> */}
//             </Grid>
//             {/* {alerts.map((a, i) => (
//               <AlertRow key={i} type={a.type} title={a.title} sub={a.sub} />
//             ))} */}
//           </SectionCard>
//         </Grid>

//         {/* ══ ROW 3: All Customers + In-Transit ══ */}

//         {/* All 161 Customers — scrollable list with cylinder count */}
//         <Grid item xs={12} lg={8}>
//           <SectionCard
//             title={`All Customers (${allCustomers.length})`}
//             icon={Person}
//             iconColor="#6B21A8"
//             badge="Total"
//             loading={loading}
//             headerRight={
//               <TextField
//                 size="small"
//                 placeholder="Search customer..."
//                 value={custSearch}
//                 onChange={(e) => setCustSearch(e.target.value)}
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <Search sx={{ fontSize: 15, color: C.muted }} />
//                     </InputAdornment>
//                   ),
//                 }}
//                 sx={{
//                   width: 180,
//                   "& .MuiInputBase-input": { fontSize: 12 },
//                   "& fieldset": { borderColor: C.border },
//                 }}
//               />
//             }
//           >
//             {/* Build a holding map: cust_name → cylinder count */}
//             {(() => {
//               const holdMap = {};
//               holdingData.forEach((h) => {
//                 const name = (h.customer_name || "").trim();
//                 if (name) holdMap[name] = (holdMap[name] || 0) + (h.total_cylinders || 0);
//               });

//               const filtered = allCustomers.filter((c) =>
//                 (c.cust_name || "").toLowerCase().includes(custSearch.toLowerCase())
//               );

//               return (
//                 <Box
//                   sx={{
//                     maxHeight: 340,
//                     overflowY: "auto",
//                     pr: 0.5,
//                     "&::-webkit-scrollbar": { width: 5 },
//                     "&::-webkit-scrollbar-thumb": { background: C.border, borderRadius: 3 },
//                   }}
//                 >
//                   {/* Header row */}
//                   <Box sx={{
//                     display: "flex", justifyContent: "space-between", alignItems: "center",
//                     py: 0.75, px: 1, mb: 0.5,
//                     background: C.bg, borderRadius: "6px",
//                     position: "sticky", top: 0, zIndex: 1,
//                   }}>
//                     <Typography sx={{ fontSize: 10, fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: 0.5 }}>
//                       Customer Name
//                     </Typography>
//                     <Typography sx={{ fontSize: 10, fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: 0.5 }}>
//                     Holding
//                     </Typography>
//                   </Box>

//                   {filtered.length === 0 ? (
//                     <Typography sx={{ fontSize: 12, color: C.muted, p: 1 }}>No customers found.</Typography>
//                   ) : (
//                     filtered.map((c, i) => {
//                       const name = (c.cust_name || "").trim();
//                       const cylCount = holdMap[name] || 0;
//                       const hasHolding = cylCount > 0;
//                       return (
//                         <Box
//                           key={c.cust_id || i}
//                           sx={{
//                             display: "flex", justifyContent: "space-between", alignItems: "center",
//                             py: 0.7, px: 1,
//                             borderBottom: `1px solid ${C.border}`,
//                             "&:last-child": { borderBottom: "none" },
//                             "&:hover": { bgcolor: "#F8FAFF" },
//                             transition: "background 0.1s",
//                           }}
//                         >
//                           <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flex: 1, minWidth: 0 }}>
//                             <Box sx={{
//                               width: 22, height: 22, borderRadius: "50%", flexShrink: 0,
//                               bgcolor: hasHolding ? C.infoBg : "#F1F5F9",
//                               display: "flex", alignItems: "center", justifyContent: "center",
//                             }}>
//                               <Person sx={{ fontSize: 12, color: hasHolding ? C.info : C.muted }} />
//                             </Box>
//                             <Typography sx={{
//                               fontSize: 12, fontWeight: hasHolding ? 600 : 400,
//                               color: hasHolding ? C.navy : C.muted,
//                               overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
//                             }}>
//                               {name || "—"}
//                             </Typography>
//                           </Box>
//                           <Box sx={{
//                             minWidth: 48, textAlign: "right",
//                           }}>
//                             <Typography sx={{
//                               fontSize: 13, fontWeight: 700,
//                               color: hasHolding ? C.accent : "#CBD5E1",
//                             }}>
//                               {cylCount}
//                             </Typography>
//                             {hasHolding && (
//                               <Typography sx={{ fontSize: 9, color: C.muted, mt: "-2px" }}>cyls</Typography>
//                             )}
//                           </Box>
//                         </Box>
//                       );
//                     })
//                   )}
//                 </Box>
//               );
//             })()}
//           </SectionCard>
//         </Grid>

//         {/* In-Transit Block + Current Location Customers */}
//         <Grid item xs={12} lg={4}>
//           <Grid container spacing={2} sx={{ height: "100%" }}>


//           </Grid>
//         </Grid>

//       </Grid>
//     </Box>
//   );
// };

// export default AdminDashboard;


import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box, Grid, Card, CardContent, Typography, CircularProgress, Chip,
  TextField, InputAdornment,
} from "@mui/material";
import {
  CheckCircle, ErrorOutline, InfoOutlined, Refresh,
  Factory, Warehouse, HourglassEmpty, Warning, Build, LocalShipping,
  Person, Search, LocationOn, DirectionsCar,
} from "@mui/icons-material";
import axiosClient from "../../configs/axios";

// ── Design tokens (matches ManagementDashboard / PlantDashboard) ──────────────
const C = {
  navy:     "#1B3A6B",
  accent:   "#2563EB",
  bg:       "#F0F4F8",
  card:     "#FFFFFF",
  border:   "#E2E8F0",
  success:  "#16A34A", successBg: "#DCFCE7",
  warn:     "#D97706", warnBg:    "#FEF3C7",
  err:      "#DC2626", errBg:     "#FEE2E2",
  info:     "#2563EB", infoBg:    "#EFF6FF",
  muted:    "#64748B",
};

const REFRESH_MS = 60_000;

const getArr = (res) => {
  if (res.status !== "fulfilled") return [];
  const d = res.value?.data;
  if (Array.isArray(d)) return d;
  if (Array.isArray(d?.data)) return d.data;
  return [];
};

// ── SectionCard ───────────────────────────────────────────────────────────────
const SectionCard = ({ title, icon: Icon, iconColor = C.accent, badge, loading, children, headerRight }) => (
  <Card elevation={0} sx={{ border: `1px solid ${C.border}`, borderRadius: "12px", bgcolor: C.card, height: "100%" }}>
    <CardContent sx={{ p: "18px 20px !important", height: "100%", boxSizing: "border-box", display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1.5, flexWrap: "wrap", gap: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
          <Icon sx={{ fontSize: 16, color: iconColor }} />
          <Typography sx={{ fontSize: 13, fontWeight: 700, color: C.navy }}>{title}</Typography>
          {badge && (
            <Chip label={badge} size="small"
              sx={{ fontSize: 10, fontWeight: 600, height: 20, bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE" }}
            />
          )}
        </Box>
        {headerRight}
      </Box>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flex: 1 }}>
          <CircularProgress size={26} sx={{ color: C.accent }} />
        </Box>
      ) : <Box sx={{ flex: 1 }}>{children}</Box>}
    </CardContent>
  </Card>
);

// ── StatBox ───────────────────────────────────────────────────────────────────
// ── StatBox ───────────────────────────────────────────────────────────────────
const StatBox = ({ label, value, color = C.navy, bg = "#F8FAFC", loading }) => (
  <Box sx={{ textAlign: "center", p: "12px 8px", borderRadius: "10px", bgcolor: color, border: `1px solid ${color}` }}>
    {loading ? (
      <CircularProgress size={16} sx={{ color: "#fff" }} />
    ) : (
      <Typography sx={{ fontSize: 22, fontWeight: 700, color: "#fff", lineHeight: 1 }}>
        {value ?? "—"}
      </Typography>
    )}
    <Typography sx={{ fontSize: 10, color: "rgba(255,255,255,0.85)", textTransform: "uppercase", mt: 0.5, letterSpacing: 0.4, fontWeight: 600 }}>
      {label}
    </Typography>
  </Box>
);

// ── DataRow ───────────────────────────────────────────────────────────────────
const DataRow = ({ label, v1, v1c = C.accent, l1, v2, v2c = C.success, l2 }) => (
  <Box sx={{
    display: "flex", alignItems: "center", justifyContent: "space-between",
    py: 1, borderBottom: `1px solid ${C.border}`, "&:last-child": { borderBottom: "none" },
  }}>
    <Typography sx={{ fontSize: 12, fontWeight: 600, color: C.navy, flex: 2, pr: 1 }}>{label}</Typography>
    <Box sx={{ display: "flex", gap: 1.5, justifyContent: "flex-end" }}>
      <Box sx={{ textAlign: "center", minWidth: 52 }}>
        <Typography sx={{ fontSize: 14, fontWeight: 700, color: v1c }}>{v1 ?? "—"}</Typography>
        <Typography sx={{ fontSize: 9, color: C.muted, textTransform: "uppercase", letterSpacing: 0.3 }}>{l1}</Typography>
      </Box>
      {l2 && (
        <Box sx={{ textAlign: "center", minWidth: 52 }}>
          <Typography sx={{ fontSize: 14, fontWeight: 700, color: v2c }}>{v2 ?? "—"}</Typography>
          <Typography sx={{ fontSize: 9, color: C.muted, textTransform: "uppercase", letterSpacing: 0.3 }}>{l2}</Typography>
        </Box>
      )}
    </Box>
  </Box>
);

// ── AlertRow ──────────────────────────────────────────────────────────────────
const AlertRow = ({ type = "info", title, sub }) => {
  const M = {
    err:  { bg: C.errBg,     border: C.err,     Icon: ErrorOutline, ic: C.err     },
    warn: { bg: C.warnBg,    border: C.warn,    Icon: Warning,      ic: C.warn    },
    info: { bg: C.infoBg,    border: C.info,    Icon: InfoOutlined, ic: C.info    },
    ok:   { bg: C.successBg, border: C.success, Icon: CheckCircle,  ic: C.success },
  };
  const { bg, border, Icon, ic } = M[type] || M.info;
  return (
    <Box sx={{ display: "flex", gap: 1, p: "8px 12px", borderLeft: `3px solid ${border}`, bgcolor: bg, mb: 0.75, borderRadius: "0 8px 8px 0", "&:last-child": { mb: 0 } }}>
      <Icon sx={{ fontSize: 15, color: ic, mt: "2px", flexShrink: 0 }} />
      <Box>
        <Typography sx={{ fontSize: 12, fontWeight: 600, color: C.navy, lineHeight: 1.3 }}>{title}</Typography>
        {sub && <Typography sx={{ fontSize: 11, color: C.muted, mt: 0.2 }}>{sub}</Typography>}
      </Box>
    </Box>
  );
};

// ── ColHeader ─────────────────────────────────────────────────────────────────
const ColHeader = ({ cols }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", pb: 0.75, mb: 0.5, borderBottom: `1.5px solid ${C.border}` }}>
    <Typography sx={{ fontSize: 10, color: C.muted, fontWeight: 700, flex: 2, textTransform: "uppercase", letterSpacing: 0.4 }}>{cols[0]}</Typography>
    {cols.slice(1).map((c, i) => (
      <Typography key={i} sx={{ fontSize: 10, color: C.muted, fontWeight: 700, textAlign: "center", minWidth: 52, textTransform: "uppercase", letterSpacing: 0.4 }}>{c}</Typography>
    ))}
  </Box>
);

// ══════════════════════════════════════════════════════════════════════════════
//  MAIN COMPONENT
// ══════════════════════════════════════════════════════════════════════════════
const AdminDashboard = () => {
  const [plantRows, setPlantRows]         = useState([]);
  const [depotStats, setDepotStats]       = useState({
    full: null, empty: null, maintenance: null,
    plantFull: null, plantEmpty: null,
    depotFull: null, depotEmpty: null,
    inTransit: null,
  });
  const [qcStats, setQcStats]             = useState({ ok: null, failed: null, total: null });
  const [alerts, setAlerts]               = useState([]);
  const [depotCylRows, setDepotCylRows]   = useState([]);
  const [loading, setLoading]             = useState(true);
  const [lastRefreshed, setLastRefreshed] = useState(null);
  const [holdingSynopsis, setHoldingSynopsis] = useState({ totalCustomers: 0, totalCylinders: 0 });
  const [allCustomers, setAllCustomers]   = useState([]);
  const [holdingData, setHoldingData]     = useState([]);
  const [inTransitData, setInTransitData] = useState([]);
  const [custSearch, setCustSearch]       = useState("");
  const timerRef = useRef(null);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const [
        productionRes, inventoryRes, depotCylRes, holdingRes,
        qcSummaryRes, customerCountRes, allCustomersRes, inTransitRes,
      ] = await Promise.allSettled([
        axiosClient.get("/dashboard/production"),
        axiosClient.get("/dashboard/inventory"),
        axiosClient.get("/dashboard/depot-cylinder-count"),
        axiosClient.get(`/reports/EmptyCylinderHolding?page=0&size=999&searchKey=`),
        axiosClient.get("/dashboard/qc-summary"),
        axiosClient.get("/customers/list?page=0&size=1&searchKey="),
        axiosClient.get(`/customers/list?page=0&size=999&searchKey=`),
        axiosClient.get(`/cylinder/intransit`),
      ]);

      const prodData = (() => {
        if (productionRes.status !== "fulfilled") return [];
        const d = productionRes.value?.data;
        return Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : []);
      })();
      const plantMap = {};
      prodData.forEach((row) => {
        const key = row.plant_name || "Unknown";
        if (!plantMap[key]) plantMap[key] = { name: key, qty: 0, cylinders: 0, carbide: 0, acetone: 0 };
        plantMap[key].qty       += parseFloat(row.total_qty_filled || 0);
        plantMap[key].cylinders += parseInt(row.cylinder_count || 0, 10);
        plantMap[key].carbide   += parseFloat(row.carbide || 0);
        plantMap[key].acetone   += parseFloat(row.acetone || 0);
      });
      setPlantRows(Object.values(plantMap));

      if (inventoryRes.status === "fulfilled") {
        const inv = inventoryRes.value?.data;
        if (inv) {
          setDepotStats({
            full:        (inv.full?.tgpl  || 0) + (inv.full?.customer  || 0),
            empty:       (inv.empty?.tgpl || 0) + (inv.empty?.customer || 0),
            maintenance: inv.maintenance || 0,
            plantFull:   inv.plant?.full  || 0,
            plantEmpty:  inv.plant?.empty || 0,
            depotFull:   inv.depot?.full  || 0,
            depotEmpty:  inv.depot?.empty || 0,
           inTransit:   (inv.inTransit?.empty || 0) + (inv.inTransit?.full || 0), 
          });
        }
      }

      const depotCylData = depotCylRes.status === "fulfilled"
        ? (Array.isArray(depotCylRes.value?.data) ? depotCylRes.value.data : []) : [];
      setDepotCylRows(depotCylData);

      if (qcSummaryRes.status === "fulfilled") {
        const qc = qcSummaryRes.value?.data || {};
        setQcStats({ ok: Number(qc.qc_pass || 0), failed: Number(qc.qc_fail || 0), total: Number(qc.total_inspected || 0) });
      } else {
        setQcStats({ ok: 0, failed: 0, total: 0 });
      }

      const holdRaw = getArr(holdingRes);
      const customerListData = getArr(customerCountRes);
      const totalCustomersFromMaster = customerListData.length > 0 ? Number(customerListData[0].totalCount || 0) : 0;

      setHoldingSynopsis({
        totalCustomers: totalCustomersFromMaster,
        totalCylinders: holdRaw.reduce((s, r) => s + Number(r.total_cylinders || 0), 0),
      });

      const newAlerts = [];
      const sorted = [...holdRaw].sort((a, b) => (b.total_cylinders || 0) - (a.total_cylinders || 0));
      if (sorted.length === 0) {
        newAlerts.push({ type: "ok", title: "No customer holding", sub: "No cylinders currently held by customers" });
      } else {
        sorted.slice(0, 5).forEach((row) => {
          newAlerts.push({ type: "info", title: row.customer_name || "Unknown Customer", sub: `${row.total_cylinders || 0} cylinders held` });
        });
      }
      setAlerts(newAlerts);
      setAllCustomers(getArr(allCustomersRes));
      setHoldingData(holdRaw);

      const inTransitRaw = (() => {
        if (inTransitRes.status !== "fulfilled") return [];
        const d = inTransitRes.value?.data;
        return Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : []);
      })();
      setInTransitData(inTransitRaw);
      setLastRefreshed(new Date());
    } catch (err) {
      console.error("AdminDashboard error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(fetchAll, REFRESH_MS);
    return () => clearInterval(timerRef.current);
  }, [fetchAll]);

  return (
    <Box sx={{ p: { xs: "12px", sm: "16px", md: "20px" }, bgcolor: C.bg, minHeight: "100vh" }}>

      {/* ── HEADER ── */}
      <Box sx={{
        display: "flex", alignItems: "center", justifyContent: "space-between",
        flexWrap: "wrap", gap: 2, mb: 2.5,
      }}>
        <Box>
          <Typography sx={{ fontSize: 18, fontWeight: 700, color: C.navy }}>Admin Dashboard</Typography>
          <Typography sx={{ fontSize: 12, color: C.muted, mt: 0.3 }}>
            Plant Production · Depot Inventory · Inspection Status · Customer Holding
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
          {lastRefreshed && (
            <Typography sx={{ fontSize: 11, color: C.muted }}>
              Updated {lastRefreshed.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" })}
            </Typography>
          )}
          <Chip
            label="Admin" size="small"
            icon={<CheckCircle sx={{ fontSize: "13px !important", color: `${C.info} !important` }} />}
            sx={{ bgcolor: C.infoBg, color: C.info, border: "0.5px solid #BFDBFE", fontSize: 11, fontWeight: 500 }}
          />
          <Box component="span" onClick={fetchAll} title="Refresh now"
            sx={{ cursor: "pointer", color: C.muted, display: "flex", alignItems: "center", "&:hover": { color: C.accent } }}>
            <Refresh sx={{ fontSize: 18 }} />
          </Box>
        </Box>
      </Box>

      {/* ── MAIN LAYOUT: Left col (5) + Right col (7) ── */}
      <Grid container spacing={2} alignItems="stretch">

        {/* ════ LEFT COLUMN ════ */}
        <Grid item xs={12} lg={5} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

          {/* Depot — Cylinder Stock */}
          <Box>
            <SectionCard title="Depot — Cylinder Stock" icon={Warehouse} iconColor="#0891B2" loading={loading} badge="Live">
              <Grid container spacing={1.5}>
                <Grid item xs={6}>
                  <StatBox label="Full Cylinders"   value={depotStats.full}        color={C.success} bg={C.successBg} />
                </Grid>
                <Grid item xs={6}>
                  <StatBox label="Empty Cylinders"  value={depotStats.empty}       color={C.warn}    bg={C.warnBg} />
                </Grid>
                <Grid item xs={6}>
                  <StatBox label="In Maintenance"   value={depotStats.maintenance} color={C.err}     bg={C.errBg} />
                </Grid>
                <Grid item xs={6}>
                  <StatBox label="Total In-Transit" value={depotStats.inTransit}   color={C.accent}  bg={C.infoBg} />
                </Grid>
              </Grid>
            </SectionCard>
          </Box>

          {/* Cylinder Stock — Plant & Depot */}
          <Box>
            <SectionCard title="Cylinder Stock — Plant & Depot" icon={Warehouse} iconColor="#0891B2" loading={loading} badge="Live">
              <ColHeader cols={["Location", "Full", "Empty"]} />
              <DataRow
                label="Plant"
                v1={depotStats.plantFull}  l1="Full"  v1c={C.success}
                v2={depotStats.plantEmpty} l2="Empty" v2c={C.warn}
              />
              <DataRow
                label="Depot"
                v1={depotStats.depotFull}  l1="Full"  v1c={C.success}
                v2={depotStats.depotEmpty} l2="Empty" v2c={C.warn}
              />
            </SectionCard>
          </Box>

        </Grid>

        {/* ════ RIGHT COLUMN ════ */}
        <Grid item xs={12} lg={7} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

     
          <Box>
            <SectionCard title="Top Customer Cylinder Holding" icon={HourglassEmpty} iconColor={C.warn} loading={loading} badge="Top 5">
              <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
                <Grid item xs={6} sm={3}>
                  <StatBox label="Total Customers" value={holdingSynopsis.totalCustomers} color={C.accent} bg={C.infoBg} />
                </Grid>
              </Grid>
              {alerts.map((a, i) => (
                <AlertRow key={i} type={a.type} title={a.title} sub={a.sub} />
              ))}
            </SectionCard>
          </Box>

          {/* All Customers — scrollable list */}
          <Box sx={{ flex: 1 }}>
            <SectionCard
              title={`All Customers (${allCustomers.length})`}
              icon={Person}
              iconColor="#6B21A8"
              badge="Total"
              loading={loading}
              headerRight={
                <TextField
                  size="small"
                  placeholder="Search customer..."
                  value={custSearch}
                  onChange={(e) => setCustSearch(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search sx={{ fontSize: 15, color: C.muted }} />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    width: 180,
                    "& .MuiInputBase-input": { fontSize: 12 },
                    "& fieldset": { borderColor: C.border },
                  }}
                />
              }
            >
              {(() => {
                const holdMap = {};
                holdingData.forEach((h) => {
                  const name = (h.customer_name || "").trim();
                  if (name) holdMap[name] = (holdMap[name] || 0) + (h.total_cylinders || 0);
                });

                const filtered = allCustomers.filter((c) =>
                  (c.cust_name || "").toLowerCase().includes(custSearch.toLowerCase())
                );

                return (
                  <Box sx={{
                    maxHeight: 300,
                    overflowY: "auto",
                    pr: 0.5,
                    "&::-webkit-scrollbar": { width: 5 },
                    "&::-webkit-scrollbar-thumb": { background: C.border, borderRadius: 3 },
                  }}>
                    {/* Sticky header */}
                    <Box sx={{
                      display: "flex", justifyContent: "space-between", alignItems: "center",
                      py: 0.75, px: 1, mb: 0.5,
                      background: C.bg, borderRadius: "6px",
                      position: "sticky", top: 0, zIndex: 1,
                    }}>
                      <Typography sx={{ fontSize: 10, fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: 0.5 }}>
                        Customer Name
                      </Typography>
                      <Typography sx={{ fontSize: 10, fontWeight: 700, color: C.muted, textTransform: "uppercase", letterSpacing: 0.5 }}>
                        Holding
                      </Typography>
                    </Box>

                    {filtered.length === 0 ? (
                      <Typography sx={{ fontSize: 12, color: C.muted, p: 1 }}>No customers found.</Typography>
                    ) : (
                      filtered.map((c, i) => {
                        const name = (c.cust_name || "").trim();
                        const cylCount = holdMap[name] || 0;
                        const hasHolding = cylCount > 0;
                        return (
                          <Box
                            key={c.cust_id || i}
                            sx={{
                              display: "flex", justifyContent: "space-between", alignItems: "center",
                              py: 0.7, px: 1,
                              borderBottom: `1px solid ${C.border}`,
                              "&:last-child": { borderBottom: "none" },
                              "&:hover": { bgcolor: "#F8FAFF" },
                              transition: "background 0.1s",
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flex: 1, minWidth: 0 }}>
                              <Box sx={{
                                width: 22, height: 22, borderRadius: "50%", flexShrink: 0,
                                bgcolor: hasHolding ? C.infoBg : "#F1F5F9",
                                display: "flex", alignItems: "center", justifyContent: "center",
                              }}>
                                <Person sx={{ fontSize: 12, color: hasHolding ? C.info : C.muted }} />
                              </Box>
                              <Typography sx={{
                                fontSize: 12, fontWeight: hasHolding ? 600 : 400,
                                color: hasHolding ? C.navy : C.muted,
                                overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                              }}>
                                {name || "—"}
                              </Typography>
                            </Box>
                            <Box sx={{ minWidth: 48, textAlign: "right" }}>
                              <Typography sx={{ fontSize: 13, fontWeight: 700, color: hasHolding ? C.accent : "#CBD5E1" }}>
                                {cylCount}
                              </Typography>
                              {hasHolding && (
                                <Typography sx={{ fontSize: 9, color: C.muted, mt: "-2px" }}>cyls</Typography>
                              )}
                            </Box>
                          </Box>
                        );
                      })
                    )}
                  </Box>
                );
              })()}
            </SectionCard>
          </Box>

        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminDashboard;


